import { useSyncExternalStore } from 'react';

const listeners = new Set<() => void>();
let count = 0;
let dismissedHold: number | null = null;

const emit = () => listeners.forEach((listener) => listener());

export const registerInlineHoldNotice = () => {
  count += 1;
  emit();

  return () => {
    count -= 1;
    emit();
  };
};

export const setDismissedHold = (hold: number | null) => {
  if (dismissedHold === hold) return;

  dismissedHold = hold;
  emit();
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = () => count > 0;

const getServerSnapshot = () => false;

const getDismissedHold = () => dismissedHold;

const getServerDismissedHold = () => null;

export const useHasInlineHoldNotice = () =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

export const useDismissedHold = () =>
  useSyncExternalStore(subscribe, getDismissedHold, getServerDismissedHold);
